module.exports = __webpack_public_path__ + "static/media/tutorial-title.abde068a.png";